export default {
    labels: [],
    labelsLoading: false,
    products: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        orderNumber: null,
        labelStatus_id: 10
    }
}
